<template>
  <v-item-group v-model="color">
    <v-layout row>
      <v-flex pa-2 v-for="(color, i) in colors" v-bind:key="i" xs3>
        <v-item v-slot:default="{ active, toggle }">
          <v-card tile flat v-on:click="toggle" v-bind:color="color" v-bind:min-height="height">
            <v-scroll-y-transition>
              <div v-if="active" class="display-3 flex-grow-1 text-center">
                <v-icon dark large>mdi-check</v-icon>
              </div>
            </v-scroll-y-transition>
          </v-card>
        </v-item>
      </v-flex>
    </v-layout>
  </v-item-group>
</template>
<script>
export default {
  name: 'v-color-group',
  props: {
    height: {type: Number, default: 70},
    value: {type: String, default: '#E0E0E0'}
  },
  data: () => ({
    color: 0,
    colors: ['#E0E0E0']
  }),
  watch: {
    color(){
      this.$emit('input', this.colors[this.color])
    }
  },
  methods: {
    init(color){
      const index = this.colors.indexOf(color)
      if(index >= 0) this.color = index
    }
  }
}
</script>
